import { VideoV1 } from '@ilteducation/content-registry-types';
import store from '@/store';

export const useOrderedVideos = () => {
  const fetchVideos = (areaId: string) =>
    store
      .dispatch('videos/getList', {
        filter: {
          'orderedAreas.id': [areaId],
        },
        pagination: {
          limit: 100,
        },
      })
      .then((videos) =>
        videos.data.sort(
          (a: VideoV1, b: VideoV1) =>
            (a.orderedAreas.find((oa) => oa.id === areaId)?.order ?? 0) -
            (b.orderedAreas.find((oa) => oa.id === areaId)?.order ?? 0),
        ),
      );

  return {
    fetchVideos,
  };
};
